export default {
    app_name: 'Order management system',
    welcome: 'Welcome ',
    login: 'Login',
    logout: 'Logout',
    user_name: 'Username',
    user_position: 'Design Level',
    user_isActive: 'Is Active',
    password: 'Password',
    dashboard: 'Daskboard',
    imported_files: 'Import Orders',
    orders:'Orders',
    scanorder:'Check order',
    scanorder_kim: 'Quay kim',
    scanorder_xi: 'Xi',
    scanorder_bong: 'Bóng',
    scanorder_nham: 'Nhám',
    production:'Products',
    changed_wo: 'Changed Work Orders',
    last_change_note: 'Thông tin thay đổi mới nhất',
    items: 'Items',
    itemmappings: 'Item Mapping',    
    users:'Users',
    shops: 'Stores',
    settings: 'Settings',
    logs: 'Logs',
    sql_executor: 'SQL Executor',
    name: 'File Name',
    workcards: 'Work Cards',
    work_orders: 'Work Orders',
    work_orders_ckfiles: 'Ck files',
    order_no: 'Order Number',
    order_status: 'Order Status',
    order_date: 'Order Date',
    uploaded_at: 'Uploaded At',
    customer_email: 'Customer Email',
    customer_name: 'Customer', 
    customer_country: 'Country',    
    ship_to: 'Ship to',
    wo_count: 'Number of Work Order',
    imageURL: 'Image',    
    action: '',
    work_order_name:'Name',
    work_order_price: 'Price',
    work_order_options: 'Options',
    work_order_status: 'Status',
    work_order_action: '',
    work_order_tthk: 'CS Review',
    button_export:'Export',
    button_export_by_worker: 'Export workorder list by worker',
    button_edit:'Edit',
    button_ck: 'Đã cắt/khắc',
    button_kt: 'Kiểm tra',
    button_delete: 'Delete',
    button_activate: 'Activate',
    button_deactivate: 'Deactivate',
    button_add: 'Add',
    button_view: 'View',
    button_review: 'review',
    button_upload: 'Upload',
    button_login: 'Login',
    button_clear: 'Clear',
    button_refresh: 'refresh',
    button_reload: 'Reload', 
    button_save: 'Save',
    button_clone: 'Clone', 
    button_ready_for_designer:'Chuyen toi designer',
    button_ready_for_worker:'Chuyen toi tho',
    button_ready_for_shiper:'Chuyen toi shipper',
    button_back_to_service:'Chuyen toi service',
    button_done:'Hoan thanh',
    button_handover_to_admin:'Chuyen toi admin',
    button_back:'Back',
    button_ok:'OK',
    button_upload_custmer_files: 'Upload hình',
    button_upload_order: 'Upload đơn hàng',
    button_print:'Print',
    button_print_preview: 'Print preview',
    button_filter:'Filter',
    button_kim:'Đã quay kim',
    button_release: 'Release',
    button_occuppy: 'Occuppy',    
    button_change: 'Change',
    label_status:'Status', 
    label_current_status: 'Current Status',   
    label_note:'Note',
    placeholder_note:'Note',       
    imported_file_id: 'ID',
    imported_file_name: 'Filename',
    imported_date: 'Imprted date',
    order_status_info:'Select status',
    order_status_new:'New',
    order_status_inprogress:'In progress',
    order_status_completed:'Completed',
    order_status_shipto_country:'Transfered',
    order_status_shipto_customer:'Delivered',
    order_status_closed:'Closed',
    order_status_cancelled:'Cancelled',  
    order_status_fix: 'Fix',  
    order_status_deleted:'Deleted', 
    order_note: 'Note for status changing',  
    work_order_id:'ID',
    work_order_no: 'Work Order No', 
    work_orders_of_order: 'Details List',
    work_order_work_card_no: 'Work Card No',
    work_order_order_date_S: 'Order Date',
    work_order_order_date: 'Order Date',
    work_order_leadTimeProduction: 'Lead Time Production',
    work_order_worker_info: 'Select a worker',
    work_order_worker:'Worker',
    work_order_start_date: 'Start date',
    work_order_end_date: 'End date',
    work_order_code:'Code',
    work_order_code_p: 'P Code',
    work_order_font: 'Font',
    work_order_color: 'Color',
    work_order_type: 'Type',
    work_order_quantity: 'Quantity',
    work_order_quantity_s: 'Qty',
    work_order_design_level: 'Design Level',
    work_order_size:'Size',
    work_order_customer: 'Customer',
    work_order_ckExportFile: 'CK Export file',
    work_order_customer_s: 'Customer',
    work_order_country: 'Country',
    work_order_vobaocount: 'Số lần vô bao',
    work_order_shipcount : 'Số lần ship',  
    work_order_errorcount: 'Số lần lỗi xi', 
    work_order_urgent: 'Urgent',
    work_order_store:'Store',
    work_order_other_options: 'Other options',
    work_order_personalization: 'Personalization',
    work_order_image_face: 'Front',
    work_order_image_back: 'Back',
    work_order_customer_note: 'Customer Note',
    work_order_special_note: 'YCDB Thợ',
    work_order_ycdb_shipping: 'YCDB Shipping',
    work_order_additions: 'Other information',
    work_order_web_deadline: 'Web Deadline',
    work_order_prod_deadline: 'Production Deadline',
    work_order_urgent_level: 'Urgent Level',
    work_order_shiptime: 'Ship Time', 
    work_order_web_dealine: 'Web Deadline',
    work_order_prod_dealine: 'Production Deadline',
    work_order_original_info: 'Original Info',  
    work_order_exported: 'Last export',  
    wo_by_status: 'Work Order by status',
    wo_goto_details: 'View details',
    work_order_productive: 'Exported For production',
    work_order_productive_at: 'Exported For production At', 
    work_order_productive_redo: 'Change tail',
    work_order_shipto: 'Ship to',
    work_order_urgent_by_cust: 'Urgent Required',  
    order_country_all:'All countries',
    order_status_all:'All status',
    workorder_status_all:'All status',
    work_order_status_new:'New',
    work_order_status_to_admin:'Handover to admin',
    work_order_status_to_designer:'Handover to designer',
    work_order_status_to_worker:'Handover to worker',
    work_order_status_to_service:'Handover to service',
    work_order_status_to_ship:'Ready to ship',
    work_order_status_designed:'Design completed',
    work_order_status_design_require_info:'More info to design',
    work_order_status_worker_completed:'Item completed',
    work_order_status_worker_require_info:'More info to work',  
    work_order_status_tobefix:'Can sua chua',    
    item_title: 'Item',
    item_name: 'Name',
    item_sku:'Sku',
    item_category: 'Category',
    item_color: 'Color',
    item_design: 'Model',
    item_size: 'Size',
    item_options: 'Other options',
    item_price: 'Price',
    item_description: 'Description',
    item_shop: 'Shop',
    item_assigned_to: 'Designer',
    item_assigned_at: 'Ngày chia thợ',
    item_id: 'ID',
    item_upload_title: 'Upload images',
    item_images_title:'Images',
    work_order_images: 'Hình ảnh',
    work_order_mau: 'Không Mẫu',
    item_type: 'Type',    
    order_date_from: 'Ordered from',
    order_date_to: 'Ordered to',
    work_card_id:'ID',
    work_card_status: 'Status',
    work_card_action: '',
    work_card_status_available: 'Available',
    work_card_status_occuppied: 'Occupied', 
    user_id: 'ID',
    user_username: 'Username',
    user_firstname: 'First Name',
    user_skus: 'SKU',
    user_lastname:'Last Name',
    user_role:'Role',
    user_working_shop:'Store',
    user_password:'Password',
    user_action:'', 
    shop_name:'Name',
    shop_description:'Description',
    shop_pcode:'P Code',    
    shop_action:'',   
    shop_id:'ID',
    shop_desc:'Mo ta chi tiet',           
    msg_saved_info: 'Information is saved.',
    msg_saved_error: 'Error occured while saving information. Check log file for more details.',
    msg_clone_info: 'A clone of work order is created.',
    msg_clone_error: 'Error occured while cloning work order. Check log file for more details.',
    msg_upload_validate_file: 'Please select files to upload.',
    msg_upload_validate_id: 'Please save information before uploading files.',
    msg_item_mapping_ok: 'Save data successfully.',
    msg_item_update_ok: 'Updated successfully.',
    msg_item_create_ok: 'Created successfully.',
    msg_item_name_missing: 'Please enter item name',
    msg_item_sku_missing: 'Please enter item sku',
    msg_store_missing: 'Vui lòng nhập store',
    msg_sku_missing: 'Vui lòng nhập sku',
    msg_username_missing: 'Vui lòng nhập username',    
    msg_item_categoty_missing: 'Please enter item category',
    msg_item_shop_missing: 'Please enter shop name',    
    msg_import_nodata:'No new data is imported',
    msg_delete_origin_workorder:'Could not delete origin work order.',
    msg_delete_origin_workorder_cfm:'Delete origin work order',
    msg_wait_vck_change_confirm: 'Bạn có muốn thay đổi?',
    msg_export_ck_change_confirm: 'Bạn có muốn thay đổi?',
    msg_delete_workorder_cfm:'Delete work order',
    msg_shop_update_ok:'Updated successfully.',
    msg_shop_create_ok:'Created successfully.',
    msg_upload_image_ok: 'Upload images successfully',
    msg_upload_image_ko: 'Failed to upload images',
    msg_shop_name_missing:'Please enter store',
    msg_user_username_missing:'Please enter username',
    msg_user_firstname_missing:'Please enter firstname',
    msg_user_lastname_missing:'Please enter lastname',
    msg_user_password_missing:'Please enter password',
    msg_user_workingshop_missing:'Please enter working store',
    msg_user_role_missing:'Please enter role',
    msg_user_update_ok:'Updated successfully.',
    msg_user_create_ok:'Created successfully.',   
    msg_print_preview_info:'Please select order for print preview', 
    msg_holiday_fromdate_missing: 'Please select from date',
    msg_holiday_todate_missing: 'Please select to date',
    msg_holiday_desc_missing: 'Please select description',
    msg_holiday_update_ok:'Information is saved.', 
    msg_change_confirm: 'Do you want to change?',
    msg_wait_vobao_ship_change_confirm: 'Do you want to change?',
    msg_all_vobao_change_confirm: 'The work orders of this order is package. Do you want to change to shipping?',
    msg_all_vobao_change_confirm_1: 'ORDER',
    msg_all_vobao_change_confirm_2: 'đã đủ món, ship?',    
    msg_all_ship_change_confirm: 'The work orders of this order is shipping. Bạn có muốn chuyến qua shipping?',
    msg_ship_confirm: 'Bạn có muốn ship?',
    msg_ship_single_1: 'Đơn hàng còn ',
    msg_ship_single_2: ' work orders nữa, có ship không?',    
    msg_title_confirm: 'Update Information', 
    msg_title_confirm_conti: 'Xác nhận',
    msg_change_wo_confirm: 'Are you sure to change this work order?',
    msg_review_wo_confirm: 'Bạn có muốn thay đổi?',
    msg_package_wo_confirm: 'Are you sure to package?',
    msg_package_wo_change_confirm: 'Bạn có muốn đổi package?',
    msg_package_wo_confirm_note: 'Bạn có muốn thêm ghi chú cho package?',
    msg_change_ds_confirm: 'Are you sure to change designer?',
    msg_change_wk_confirm: 'Are you sure to change worker for selected work orders?',
    msg_chot_tho_confirm: 'Are you sure to confirm worker for selected work orders?',
    msg_change_wo_forbidden: 'Forbidden to change info.', 
    msg_change_wo_assign_forbidden: 'Đơn hàng chưa chia thợ. Không thể thay đổi.',
    msg_change_wo_per_forbidden: 'Forbidden to change personalization.',      
    msg_complete_ck_without_assign: 'Không thể thay đổi vì có chi tiết đơn hàng chưa được phân công thợ.',     
    error_selected_items_not_assignable: 'Chọn chi tiết đơn hàng \'Đã xuất cắt/khắc\' để assign', 
    note_need_more_info:'Need more info',
    note_others: 'Others',
    holiday_start: 'From date',
    holiday_end: 'To date',
    holiday_description: 'Description',
    holiday_action: '',
    holiday_title: 'Holiday Management',
    holiday_list_title: 'Holidays in year',
    dialog_title: 'Update Work Order',
    dialog_msg: 'Do you want to change?',
    dialog_clone_msg: 'Do you want to clone this work order?',
    dialog_leave_msg: 'Do you want to save information before leaving?',
    current_status: 'Current status: ',
    talk_msg: 'Discussion: ', 
    talk_msg_holder: 'Discussion information',
    talk_to: 'Send to: ',
    button_mark: 'Đã xuất c/k',
    button_mark_reviewed: 'Đã review',
    button_change_status: 'Đổi tình trạng',
    to_service: 'Service',
    to_admin: 'Admin',
    to_designer: 'Design',
    to_shipping: 'Shipping',
    to_shipping_d: 'Shipping Domestic',
    to_khac: 'Khac',
    to_worker: 'Worker',
    lbl_worker: 'Thợ',
    button_send_to: 'Gửi trao đổi',
    talk_msg_missing: 'Vui lòng nhập trao đổi',
    talk_to_missing: 'Vui lòng chọn người nhận',
    msg_created_ok: 'Trao đổi đã được gửi đi',
    msg_updated_ok: 'Trao đổi đã được thay đổi',
    talks: 'Talks',
    ResetToNew: 'Reset form to create new',
    imported_orders: 'Orders existed/Invalid',
    imported_orders_count: 'Number of imported orders: ',
    work_order_shipping_error_detail: 'Error details',
    work_order_shipping_note: 'Note',
    khac_list: 'Work Order List',
    super_list: 'Danh sách chi tiết',
    super_list_ext: 'Danh sách chi tiết (Len Da Inox)',
    super_list_prt: 'Danh sách đuôi chuột đã in',
    wo_wait_for_ship: 'Wait for shipping',
    wo_shipped: 'Shipped',
    wo_shipped_not: 'Chưa ship',
    wo_shipped_all: 'All',    
    button_package: 'NHẬP MÃ PACKAGE', 
    button_change_package: 'ĐỔI MÃ PACKAGE',
    package_code: 'PACKAGE CODE',
    ship_packages: 'PACKAGES',
    ship_khaihq: 'KHAI HQ',
    ship_dhl: "DHL",
    ship_code: 'Ship Number',
    ship_note: 'Ghi chú vận đơn',
    ship_at: 'Ship Date',
    button_change_designer: 'Change designer',
    button_change_worker: 'Assign worker',
    button_change_worker_only: 'Thay đổi thợ',
    wo_package_date: 'Package date',
    wo_package_no: 'Package no',
    wo_package_note: 'Ghi chú',
    button_package_note: 'Thêm ghi chú',
    error_selected_items_empty: 'Please select workorder',
    error_selected_ready_items_empty: 'Vui lòng chọn chi tiết đơn hàng đã sẵng sàng cho ck',
    error_selected_assigned_items_empty: 'Vui lòng chọn chi tiết đơn hàng đã assigned tho',
    error_selected_worker_empty: 'Vui lòng chọn thợ',
    error_ship_items_empty: 'Please select shippable workorder',
    error_ship_items_invalid: 'Please select shippable workorder only',
    error_ship_date_invalid: 'Vui lòng chỉ chọn ngày vận đơn',
    error_ship_code_invalid: 'Vui lòng chỉ chọn số vận đơn',
    work_order_designer: 'Designer',
    lbl_caption_update: 'Cập nhật tình trạng',
    error_selected_items_empty_invalid: 'Vui lòng chỉ chọn chi tiết đơn hàng có thiết kế đã được approved',
    error_reviewed_items_empty_invalid: 'Vui lòng chỉ chọn chi tiết đơn hàng có thiết kế đã được duyệt',
    work_ngay_nhap_lieu: 'Ngày nhập liệu',
    button_combine: 'SHIP CHUNG',
    msg_title_combine: 'SHIP CHUNG',
    ckfiles_excel: 'File Excel Đã xuất cắt/khắc',
    ckfiles_corel: 'File Corel Đã xuất cắt/khắc',
    ckfiles_corel_s: 'File Corel',
    ckfiles_quantity: 'Số lượng',
    ckfiles_readyCk: 'Số lượng sẵn sàng cho CK',
    ckfiles_exportedCk: 'Số lượng exported CK',
    ckfiles_assignedCk: 'Số lượng assigned thợ',    
    ckfiles_doneCk: 'Số lượng đã CK',    
    ckfiles_ngayck: 'Ngày xuất cắt/khắc',
    ckfiles_complete_ck: 'Ngày cắt/khắc',
    button_export_ck: 'Xuất cắt/khắc',
    wo_count_by_deadline: 'DANH SÁCH TRỄ HẠN SX',
    wo_count_by_reprint_tail: 'IN LẠI ĐUÔI CHUỘT',
    wo_deadline: 'TRỄ HẠN SX',
    wo_deadline_yes: 'TRỄ HẠN',
    wo_deadline_no: 'Không TRỄ HẠN',
    wo_deadline_all: 'Tất cả',
    wo_by_deadline: 'Ngày TRỄ HẠN SX',
    wo_asign_only: 'Chỉ đổi thợ',
    work_order_status_already_existed: 'Tình trạng của đơn hàng đã được cập nhật.',
    work_order_invalid_status: 'Trạng thái hiện thời không hợp lệ để chuyển sang trạng thái mới',
    work_order_invalid_status_bong: 'Trạng thái đơn hàng không phải là bóng hoặc lỗi chờ sửa',
    work_order_invalid_status_nham: 'Trạng thái đơn hàng không phải là nhám hoặc đã cắt khắc hoặc lỗi chờ sửa',
    work_order_invalid_status_assign_xi: 'Trạng thái đơn hàng không phải là phân công thợ hoặc đã xi',
    item_semi: 'Semi',
    button_continue: 'TIẾP TỤC',
    button_cancel: 'CANCEL',
    button_error: 'LỖI',
    wo_semi: 'Semi',
    wo_ignore_semi: 'Tất cả',
    button_semi: 'Cần semi',
    button_ready: 'Sẵn sàng cho CK',
    msg_change_to_ready_confirm: 'Bạn có muốn chuyển sang sẵn sàng cho CK?',
    msg_change_semi_confirm: 'Bạn có muốn thay đổi yêu cầu semi?',
    histories: 'Histories',
    changed_id: 'Changed ID',
    origin_value: 'Origin Value',
    updated_value: 'Updated Value',
    changed_info: 'Thông tin thay đổi',
    created_at: 'Thời gian thay đổi',
    created_by: 'Người thay đổi',
    item_info: 'Đối tượng thay đổi',
    item_additional_info:'Thông tin khác',
    wo_details_title: 'Chi tiết đơn hàng',
    lbl_assign_count: 'Số lần assign',
    lbl_assign_info: 'Assign',
    button_print_tail: 'In đuôi chuột',
    lbl_print_tail: 'Số lần In đuôi chuột',
    msg_print_tail_confirm: 'Bạn có muốn in đuôi chuột?',
    wo_no_print_worker: 'Chưa được in file thợ',
    wo_no_print_tail: 'Chưa được in đuôi chuột',
    wo_no_assigned_worker: 'Chưa được chia thợ',
    select_all: 'Tất cả',
    item_mota: 'MÔ TẢ',
    error_selected_items_not_readyable: 'Đơn hàng được chọn chưa sẵn sàng cho cắt khắc',
    worker_name: 'Thợ',
    status_exportck: 'Đã xuất cắt/khắc',
    status_ready: 'Sẵn sàng cho CK',
    status_assigned: 'Chia thợ',
    status_ck: 'Đã ck',
    status_nham: 'Nhám',
    status_bong: 'Bóng',
    status_kim: 'Kim',
    status_kiemtra: 'Kiểm tra',
    status_loichosua: 'Lỗi chờ sửa',
    status_admindaduyet: 'Admin đã duyệt',
    status_assigned_total: 'Tổng số',
    status_assigned_totalP: 'Tổng số thêm',
    button_worker_plan: 'Review',
    msg_title_worker_plan: 'Planning',
    title_phan_cong_tho: 'Phân công thợ',
    ship_wo: 'Ship đơn hàng',
    work_order_next_status: 'Tình trạng mới',
    reprint_tail: 'In lại đuôi chuột',
    reprint_tail_count: 'Số lần In lại đuôi chuột',
    materials: 'Nguyên liệu',
    materialStocks: 'Nguyên liệu',
    material_no_remain: 'Số lượng hiện tại',
    material_no_batch_no_old: 'Batch No hiện tại',
    material_no_new: 'Số lượng nhập mới',
    material_no_batch: 'Batch No nhập mới',
    material_quantity: 'Số lượng nhập mới',
    material_history_stt: 'Stt',
    material_history_code: 'Nguyên liệu',
    material_history_batch_no: 'Batch No cũ',
    material_history_batch_no_new: 'Batch No mới',
    material_history_quantity: 'Số lượng',
    material_history_remain_quantity: 'Số lượng còn lại',
    material_history_modified_by: 'Người thay',
    material_history_modified_at: 'Thời gian thay',
    material_history_material_id: 'Nguyên liệu',
    material_history_delete: 'Xóa',
    button_xi_bac_type: 'BẠC',
    button_xi_vang: 'XI VÀNG LẮC KÊ',
    button_xi_fix_vang: 'XI VÀNG TRANG TRÍ',
    button_xi_loi_vang: 'XI LỖI',
    button_xi_hong: 'XI HỒNG LẮC KÊ',
    button_xi_fix_hong: 'XI HỒNG TRANG TRÍ',
    button_xi_loi_hong: 'XI LỖI',
    button_xi_bac: 'TIẾP TỤC',
    button_xi_loi_bac: 'XI LỖI',
    material_stock_code: 'Nguyên liệu',
    material_stock_quantity: 'Số lượng',
    material_stock_so_can: 'Số Can',
    material_stock_quantity_sub: 'Số lượng chia nhỏ',
    material_stock_dung_tich: 'Dung tích',
    material_stock_batch_no: 'Batch No',
    material_stock_batch_nos: 'Danh sách Batch No',
    material_stock_seller: 'Người bán',
    material_stock_name: 'Tên',
    material_stock_date: 'Ngày nhập',
    material_stock_status: 'Tình trạng',
    material_stock_delete: '',
    material_stock_created_at: 'Ngày nhập',
    material_stock_count: 'Lần nhập',
    so_me: 'Số mẻ',
    round_ended: 'Kết thúc mẻ?',
    button_xi_confirm: 'Xác nhận',
    so_me_active: 'Mẻ hiện tại',
    so_me_inactive: 'Đổi mẻ mới khác màu',
    shipping_calendar: 'Lịch shipping',
    shipping_calendar_day: 'Ngày shipping',
    shipping_calendar_duration: 'Thời hạn',
    shipping_calendar_shipTo: 'Ship to',
    msg_calendar_day_missing: 'Vui lòng chọn ngày',
    msg_calendar_duration_missing: 'Vui lòng chọn Thời hạn',
    msg_calendar_shipTo_missing: 'Vui lòng chọn ship to',
    msg_calendar_save_confirm: 'Bạn có muốn thay đổi?',
    msg_error_missing: 'Vui lòng chọn lỗi',
    default_image_upload: 'Upload Hình thiết kế',
    design_image_name: 'File Hình thiết kế',
    design_image_content: 'Hình thiết kế',
    button_xuat: 'Xuất kho',
    material_stock_can_code: 'Loại cốc',
    button_reset: 'Reset',
    button_xk: 'Xuất kho',
    button_replaced: 'Thay nguyên liệu',
    material_current_status: 'Tình trạng hiện tại',
    inventory_stt: 'Stt',
    inventory_code: 'Nguyên liệu',
    inventory_available: 'Chưa sử dụng',
    inventory_used: 'Đã sử dụng',
    inventory_delivered: 'Đã xuất kho',
    inventory_empty: 'Sụ dụng hết',
    inventory_changing: 'Đang thay',
    inventory_deleted: 'Đã xóa',
    inventory_usable: 'Tồn kho',
    shipping_workorder_no:'Mã đơn hàng',
    button_round_history: 'Thông tin mẻ trong ngày',
    round_history: 'Thông tin mẻ trong ngày',
    material_mapping_quantity: 'Số lượng',
    material_mapping_can_code: 'Mã cốc',
    material_mapping_can_capacity: 'Dung tích cốc',
    errors: 'Danh sách lỗi',
    masx: 'Mã Sx',
    madh: 'Mã đặt hàng',
    masp: 'Mã sản phẩm',
    tho: 'Thợ',
    mau: 'Màu',
    soluong: 'Số lượng',
    kichthuoc: 'Size',
    trangthai: 'Trạng thái',
    loi: 'Lỗi',
    ngaynhaploi: 'Ngày nhập lỗi',
    ghichu: 'Ghi chú',
    btn_error_report: 'Export',
    hint_work_order_no: 'Số đơn hàng',
    error_only: 'Chỉ hiện thị đơn hàng lỗi',
    profile_xi_stt: 'STT',
    profile_xi_ten: 'Tên',
    profile_xi_vol: 'Vol',
    profile_xi_nhietdo: 'Nhiệt độ',
    profile_xi_thoigian: 'Thời gian',
    profile_xi_ph: 'PH',
    profile_xi_tytrong: 'Tỷ trọng',
    profile_xi_updateat: 'Ngày cập nhật',
    profile_xi_note: 'Ghi chú',
    profile_xi_group: 'Nhóm profile',
    button_addProfile_xi: 'Thêm profile',
    button_updProfile_xi: 'Update profile',
    msg_delete_profile_xi_confirm: 'Bạn có muốn xóa profile xi?',
    material_profile_material_code: 'Material',
    material_profile_profile_id: 'Profile Xi',
    history_batchnos: 'Danh sách Batch No',
    material_tab_stocks: 'Nhập nguyên liệu',
    material_tab_stocks_super: 'Nguyên liệu đang sử dụng',
    material_tab_profiles: 'Profile Xi',
    xi_list_batchno: 'Batch No',
    country_mapping_form: 'Cài đặt quốc gia',
    country_mapping_title: 'Danh sách quốc gia',
    country_mapping_name: 'Quốc gia',
    country_mapping_info: 'Quóc gia shipping',
    country_mapping_action: '',
    wo_csReview_0: 'Mới import',
    wo_csReview_1: 'Chưa duyệt',
    wo_csReview_2: 'Đã duyệt',
    wo_csReview_3: 'Tất cả',
    button_assign_shop: 'Assign Shop',
    shop_item: 'Assigned Shop',
    button_assign: 'Assign',
    shop_pre: 'Mã cửa hàng',
    button_chot_worker: 'Chốt thợ',
    chot_count: 'Chốt thợ',
    chot_at: 'Ngày Chốt',
    history_note: 'Chi tiết thay đổi',
    incident: 'Incident',
    button_incident: 'Resolve Incident',
    msg_resolve_incident_confirm: 'Are you sure to confirm that the incident was resolved?',
    work_order_personalization: 'Personalization',
    button_bong: 'Đã đánh bóng',
    msg_to_bong_confirm: 'Bạn có muốn chuyển sang trạng thái đã đánh bóng?',
    msg_to_status_confirm: 'Bạn có muốn chuyển sang trạng thái đã chọn?',
    msg_to_add_note_confirm: 'Bạn có muốn thêm ghi chú cho các đơn hàng đã chọn?',
    wo_count_by_suco: 'SỰ CỐ',
    wo_by_urgent: 'Gấp',
    button_da_xi: 'Đã xi',
    wo_loixi: 'Lỗi xi',
    wo_loi_others: 'Tất cả',
    wo_loi_tho: 'Lỗi thợ',
    wo_loi_catkhac: 'Lỗi cắt khắc',
    work_order_error_code: 'Mã lỗi',
    item_normal: 'None',
    item_len: 'Len không',
    item_lenda: 'Len Da',
    item_da: 'Da không',
    item_dainox: 'Da Inox',
    item_leninox: 'Len Inox',
    item_lenbac: 'Len Bạc',
    item_dabac: 'Da Bạc',
    user_department: 'Bộ phận',
    work_order_status_len: 'TT Len',
    work_order_status_da: 'TT Da',
    button_update_da_moi: '_Mới___',
    button_update_da_ss: 'Sẵn sàng sx da',
    button_update_da_da_sx: 'Đã sx',
    button_update_da_ht: 'Da hoàn thành',
    button_update_len_moi: '_Mới___',
    button_update_len_ss: 'Sẵn sàng sx len',
    button_update_len_da_sx: 'Đã sx',
    button_update_len_ht: 'Len hoàn thành',
    button_ht: 'Hoàn Thành',
    button_dasx: 'Đã sx',
    msg_wait_hoanthanh_change_confirm: 'Bạn có muốn thay đổi?',
    error_selected_ht_items_empty: 'Vui lòng chọn chi tiết đơn hàng đã hoàn thành',
    error_selected_dasx_items_empty: 'Vui lòng chọn chi tiết đơn hàng đã sx',
    work_order_itype: 'Loại',
    wo_len_da_moi: 'Mới',
    wo_len_da_ss_sx: 'Sẵn sàng sx',
    wo_len_da_da_sx: 'Đã sx',
    wo_len_da_ht_sx: 'Hoàn thành',
    wo_len_da_all: 'Tất cả',
    wo_len_da: 'Len Da',
    wo_normal: 'Bình thường',
    wo_all: 'Tất cả',
    button_refesh: 'Tải lại',
    no_details: 'Chưa có DHL',
    button_details: 'DHL Details',
    button_upload_dhl: 'Upload DHL',
    button_export_dhl: 'Export DHL',
    dhl_items: 'DHLs',
    msg_delete_dhl_confirm: 'Bạn có muốn xóa DHL?',
    item_details_nhom: 'Nhóm',
    item_details_nhom_en: 'Nhóm En',
    item_details_tenvthh: 'Tên Vthh',
    item_details_dhlDescription: 'DHL Description',
    item_details_priority: 'Priority',
    item_details_hsCode: 'HS Code',
    item_details_giaXk: 'Gia XK',
    item_details_kl: 'KL',
    msg_item_nhom_missing: 'Vui lòng nhập nhóm',
    msg_item_nhomEn_missing: 'Vui lòng nhập nhóm En',
    msg_item_dhlDescription_missing: 'Vui lòng nhập DHL Description',
    msg_item_priority_missing: 'Vui lòng nhập priority',
    msg_item_hsCode_missing: 'Vui lòng nhập HS Code',
    msg_item_giaXk_missing: 'Vui lòng nhập Giá XK',
    msg_item_kl_missing: 'Vui lòng nhập Khối lượng',
    work_order_shipping_image: 'Shipping Picture',
    msg_title_camera: 'Camera',
    reprint_tail_title: 'IN ĐUÔI CHUỘT',
    reprint_tail_desc: 'Quét mã để in lại đuôi chuột',
    printorder: 'In đuôi chuột',
    TEN_KH: 'Tên khách hàng',
    BARCODE:'BARCODE',
    MA_P: 'Mã Sx',
    ORDER_NUMBER: 'Số đơn hàng',
    GAP: 'Gấp',
    MAU: 'Màu',
    SIZE: 'Kích thước',
    CREATED_AT: 'Ngày tạo',
    CREATED_BY: 'Người tạo',
    SHIP_TO: 'Ship to',
    reprint_tail_btn: 'IN ĐUÔI CHUỘT',
    reprint_tail_khac_desc: 'Chọn đơn hàng để in lại đuôi chuột',
    reprint_tail_khac_title: 'IN LẠI ĐUÔI CHUỘT',
    filter_urgent: 'Yêu cầu gấp',
    work_order_ship_with_error: 'Ghi lỗi',
    work_order_ship_error_group: 'Lỗi',
    ship_report: 'Report',
    planning_simple: 'Simple Planning',
    planning_num_of_day: "Số ngày thực hiện (Tính từ ngày hiện tại):",
    planning_capacity_button: 'Cập nhật capacity',
    quality_report: "Quản lý chất lượng",
    quality_sodh: "SỐ ĐH",
    quality_masx: "MÃ SX",
    quality_tho: "Thợ",
    quality_ngayshipvn: "NGÀY SHIP VN",
    quality_ngaykhnhan: "NGÀY KH NHẬN HÀNG",
    quality_ngaysuco: "NGÀY SỰ CỐ",
    quality_ngayreport: "NGÀY REPORT",
    quality_loaisuco: "LOẠI SỰ CỐ",
    quality_motasuco: "MÔ TẢ SỰ CỐ",
    quality_copyhasuco: "COPY HÌNH ẢNH SỰ CỐ",
    quality_nguyennhan: "NGUYÊN NHÂN",
    quality_giaiphap: "GIẢI PHÁP",
    quality_tinhtrangsuco: "TÌNH TRẠNG SỰ CỐ",
    quality_action: '',
    quality_savesuco: "Save",
    quality_from_report_date: 'Từ Ngày Report:',
    quality_to_report_date: 'Đến Ngày Report:',
    quality_tinhtrang_filter: 'TÌNH TRẠNG SỰ CỐ',
    quality_loaisuco_filter: "LOẠI SỰ CỐ",
    quality_them_report: 'NHẬP SỰ CỐ MỚI',
    quality_xoa_confirm_msg: 'Bạn thực sự muốn xóa SỰ CỐ?',
    quality_load: 'Load',
    quality_error_code: 'Mã lỗi',
     quality_error_code_details: 'Chi tiết lỗi',
    quality_error_pcode: 'Mã SX',
    quality_error_desc: 'Chi tiết lỗi',
    quality_error_created_at: 'Ngày tạo',
    quality_error_created_by: 'Người tạo',
    quality_error_worker: 'Thợ',
    service_wo_scan: 'Scan WorkOrder',
    delivery_vn_ship_at: 'Ngày của vận đơn',
    delivery_us_received_at: 'Ngày nhận vận đơn',
    delivery_ship_packages: 'PACKAGES',
    delivery_shipus_scan: 'Ship đơn hàng',
    khac_search: "Tìm kiếm",
    button_received: "Đã nhận",
    button_ship_from_us: 'Ship From US',
    quality_export_report: 'Export Report',
    check_basket: "Kiểm tra rổ hàng",
    user_country: 'Quốc gia',
    user_region: 'Vùng',
    check_basket_holder: 'Chọn rổ hàng',
    check_shipcode_holder: 'Chọn package',
    pkg_count_by_shipvn: 'Package chưa nhận',
    pkg_count_by_nonshipus: 'Đơn hàng chờ Ship',
    view_all: 'Xem tất cả',
    button_download: 'Download',
    work_order_suco: 'Sự cố',
    button_fix_ck: 'Đã xử lý lỗi c/k',
    wo_incident: 'Sự cố',
    error_report: "Báo lỗi",
    error_report_export: 'Export',
    button_add_notes: 'Thêm ghi chú',
    button_add_donmua: 'Cập nhật đơn mùa và hạn giao mùa',
    wo_donmua: 'Đơn mùa',
    wo_hangiaomua: 'Hạn giao mùa',
    msg_to_add_donmua_confirm: 'Cập nhật đơn mùa và hạn giao mùa',
    da_ghi_thiep: 'Đã ghi thiệp',
    chua_ghi_thiep: 'Chưa ghi thiệp',
    all_ghi_thiep: 'Tất cả',
    filter_ghi_thiep: 'Yêu cầu ghi thiệp',
    button_ghi_thiep: 'Đã ghi thiệp',
    button_ghi_thiep_id: 'Tạo ghi thiệp id',
    msg_to_ghi_thiep_confirm: 'Cập nhật đã ghi thiệp?',
    lbl_da_ghi_thiep: 'Đã ghi thiệp',
    work_order_etsy_dealine: 'MARKET',
    work_order_etsy: 'MARKET',
    settings_calendar: 'Calendar',
    settings_duration: 'Duration',
    settings_shipTo: 'Ship to',
    work_order_model: 'Model',
    print_order_no: 'Ord.No',
    button_print_label: 'In Nhãn',
    settings_pc_document_file: 'Document_file',
    settings_pc_print_to_file_name: 'Print_to_file_name',
    settings_pc_print_to_file_folder: 'Print_to_file_folder',
    settings_pc_printer: 'Printer',
    settings_pc_username: 'Username',
    settings_pc_pwd: 'Pwd',
    settings_pc_save_after_print: 'Save_after_print',
    settings_pc_url: 'Url',
    settings_pc_code: 'Code',
    settings_pc_code_msg: 'Code',
    settings_pc_code_msg: 'Code',
    settings_pc_document_file_msg: 'Document_file',
    settings_pc_print_to_file_name_msg: 'Print_to_file_name',
    settings_pc_print_to_file_folder_msg: 'Print_to_file_folder',
    settings_pc_printer_msg: 'Printer',
    settings_pc_username_msg: 'Username',
    settings_pc_pwd_msg: 'Pwd',
    settings_pc_save_after_print_msg: 'Save_after_print',
    settings_pc_url_msg: 'Url',
    user_bc_print: 'Mã máy in Barcode',
    user_dc_print: 'Mã máy in chuột',
    shipPackageStatistics_shipAt: 'Ngày Ship',
    shipPackageStatistics_shipCode: 'Package',
    shipPackageStatistics_chungLoiHh: 'Chủng loại HH',
    shipPackageStatistics_count: 'Số đơn',
    shipPackageStatistics_count: 'CHỐT_DS_HQ',
    shipPackageStatistics_countTt: 'THỰCTẾ_DS_HQ',
    shipPackageStatistics_chenhLech: 'CHÊNH LỆCH',
    button_dshq: 'Tải các DS HQ',
    khaihq_shipAt: 'Ngày Ship',
    khaihq_pakage: 'MÃ package',
    khaihq_chungloaihh: 'Chủng loại HH',
    khaihq_chotdshq: 'CHỐT_DS_HQ',
    khaihq_thuctedshq: 'THỰCTẾ_DS_HQ',
    khaihq_chenhlech: 'CHÊNH LỆCH',
    msg_to_update_hansx_confirm: 'Cập nhật hạn sản xuất?',
    button_ht: 'Hoàn Thành',
}